export enum IntroductionType {
  NO_INTRO = 'NO_INTRO',
  INTRO = 'INTRO',
  INTRO_SHORT = 'INTRO_SHORT',
}
